import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cf02115"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "chat-container",
  ref: "chatcontainer"
}
const _hoisted_2 = { class: "top_left_action" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "intelligent_agent_language_tips" }, "* 智能体发言由 AI 生成", -1))
const _hoisted_5 = {
  key: 0,
  class: "chat_message_list_and_call_bg"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "list_tips" }, "对话记录", -1))
const _hoisted_8 = {
  key: 1,
  class: "interactive_buttons"
}
const _hoisted_9 = { class: "evaluation_edit_info" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "evaluation_edit_title" }
const _hoisted_12 = { class: "evaluation_edit_info" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "evaluation_edit_title" }
const _hoisted_15 = { class: "evaluation_edit_info" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "evaluation_edit_title" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "van-floating-panel__header-bar" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gradient-box" }, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "speak_center_btn_bg"
}
const _hoisted_22 = {
  key: 0,
  class: "speak_move_tips"
}
const _hoisted_23 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_SceneSwitchButton = _resolveComponent("SceneSwitchButton")!
  const _component_UmiChat = _resolveComponent("UmiChat")!
  const _component_OwnChat = _resolveComponent("OwnChat")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_VanFloatingPanel = _resolveComponent("VanFloatingPanel")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_ChatMic = _resolveComponent("ChatMic")!
  const _component_UmiAudioListenLoadingView = _resolveComponent("UmiAudioListenLoadingView")!
  const _component_UmiAudioInfoView = _resolveComponent("UmiAudioInfoView")!
  const _component_ChatLottie = _resolveComponent("ChatLottie")!
  const _component_VideoTriggerPlayView = _resolveComponent("VideoTriggerPlayView")!
  const _component_EvaluationView = _resolveComponent("EvaluationView")!
  const _component_InteractiveGuidanceView = _resolveComponent("InteractiveGuidanceView")!
  const _component_ReviewExercisesView = _resolveComponent("ReviewExercisesView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.sourceType == 0)
        ? (_openBlock(), _createBlock(_component_van_icon, {
            key: 0,
            size: _ctx.$route.query.preview ? 30 : 70,
            name: "arrow-left",
            onClick: _ctx.goBack
          }, null, 8, ["size", "onClick"]))
        : _createCommentVNode("", true),
      (!_ctx.$route.query.preview &&
        _ctx.sourceType == 1 &&
        _ctx.hasEvaluationList &&
        !_ctx.showEvaluationView &&
        !_ctx.showReviewExercisesView
      )
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "my_evaluation_bg",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toMyEvaluationClick && _ctx.toMyEvaluationClick(...args)))
          }, [
            _createVNode(_component_van_image, {
              src: require('../assets/image/my_evaluation_icon.svg')
            }, null, 8, ["src"]),
            _hoisted_3
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_4,
    (!_ctx.$route.query.preview && !_ctx.showEvaluationView && !_ctx.showReviewExercisesView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (!_ctx.iscallingUmi)
            ? (_openBlock(), _createBlock(_component_van_button, {
                key: 0,
                class: "chat_message_list_btn",
                onClick: _ctx.showChatMessageListMethod
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: require('../assets/image/chat_message_list_icon.svg'),
                    class: "list_img"
                  }, null, 8, _hoisted_6),
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.sdkToken &&
      _ctx.initUnityCallBack &&
      !_ctx.showEvaluationView &&
      !_ctx.showReviewExercisesView &&
      !_ctx.hideInteractive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_ctx.scaleIconText != '' && _ctx.scaleValid &&
        _ctx.webrtcConnect)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "evaluation_edit_button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showEvaluationViewClick && _ctx.showEvaluationViewClick(...args)))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("img", {
                    src: require('../assets/image/evaluation_edit_icon.svg'),
                    class: "evaluation_edit_icon"
                  }, null, 8, _hoisted_10),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.scaleIconText), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.chatSceneIconText != '')
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "evaluation_edit_button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showInteractiveViewClick(1)))
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("img", {
                    src: require('../assets/image/interactive_scene.svg'),
                    class: "evaluation_edit_icon"
                  }, null, 8, _hoisted_13),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.chatSceneIconText), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.storyIconText != ''
      )
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "evaluation_edit_button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showInteractiveViewClick(2)))
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("img", {
                    src: require('../assets/image/interactive_sequence.svg'),
                    class: "evaluation_edit_icon"
                  }, null, 8, _hoisted_16),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.storyIconText), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showVideoPlayTriggerView === false && !_ctx.showEvaluationView && _ctx.initUnityCallBack)
      ? (_openBlock(), _createBlock(_component_SceneSwitchButton, {
          key: 2,
          ref: "interactiveViewRef",
          onCloseInteractive: _ctx.hideInteractiveViewClick,
          onVoicePlayText: _ctx.sceneSwitchvoicePlayText,
          class: "SceneSwitchButton",
          chatMenuList: _ctx.chatMenuList,
          linkardIdParam: _ctx.linkardId,
          linkardId: _ctx.linkardId,
          interactiveId: _ctx.interactiveId,
          onSceneClick: _ctx.setRegisterSetChatParam,
          onCloseUmiSpeak: _ctx.closeUmiSpeak,
          onShowVideoPaly: _ctx.showVideoPaly,
          onSendTexttoChat: _ctx.sendTexttoChat
        }, null, 8, ["onCloseInteractive", "onVoicePlayText", "chatMenuList", "linkardIdParam", "linkardId", "interactiveId", "onSceneClick", "onCloseUmiSpeak", "onShowVideoPaly", "onSendTexttoChat"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_VanFloatingPanel, {
      height: _ctx.anchorHeight,
      "onUpdate:height": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.anchorHeight) = $event)),
      anchors: _ctx.chatAnchors,
      "content-draggable": false
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", {
          class: "van-floating-panel_header_view",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.vanFloatingPanelClick && _ctx.vanFloatingPanelClick(...args)))
        }, _hoisted_19)
      ]),
      default: _withCtx(() => [
        _hoisted_20,
        _createElementVNode("div", {
          class: _normalizeClass([
        'content',
        _ctx.anchorHeight == _ctx.chatAnchors[1] ? 'content_height' : '',
      ]),
          ref: "chatContentBg",
          id: "chat_content_bg"
        }, [
          _createVNode(_component_van_list, {
            class: _normalizeClass([
          'chat-list-content',
          _ctx.$route.query.preview ? 'chat_list_content_pc' : '',
        ]),
            finished: true
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock(_component_van_cell, { key: index }, {
                  default: _withCtx(() => [
                    (item === _ctx.currentBotAnswer)
                      ? (_openBlock(), _createBlock(_component_UmiChat, {
                          key: 0,
                          text: _ctx.currentBotAnswer.text,
                          sourceType: _ctx.sourceType,
                          isLoding: _ctx.loading,
                          triggerType: _ctx.currentBotAnswer.triggerType,
                          fromAudio: _ctx.currentBotAnswer.fromAudio,
                          onShowVideoPaly: _ctx.showVideoPaly
                        }, null, 8, ["text", "sourceType", "isLoding", "triggerType", "fromAudio", "onShowVideoPaly"]))
                      : (item.fromBot)
                        ? (_openBlock(), _createBlock(_component_UmiChat, {
                            key: 1,
                            text: item.text,
                            sourceType: _ctx.sourceType,
                            triggerType: item.triggerType,
                            fromAudio: item.fromAudio,
                            mediaUrl: item.mediaUrl,
                            url: item.url,
                            scaleIdIdentify: _ctx.scaleIdIdentify,
                            itemScaleIdentify: item.scaleIdIdentify,
                            onDismissVideoTriggerPlayView: _ctx.dismissVideoTriggerPlayView,
                            onChatScale: _ctx.chatScaleMethod,
                            onShowVideoPaly: _ctx.showVideoPaly
                          }, null, 8, ["text", "sourceType", "triggerType", "fromAudio", "mediaUrl", "url", "scaleIdIdentify", "itemScaleIdentify", "onDismissVideoTriggerPlayView", "onChatScale", "onShowVideoPaly"]))
                        : (!item.fromBot && item === _ctx.currentUserAsk)
                          ? (_openBlock(), _createBlock(_component_OwnChat, {
                              key: 2,
                              fromAudio: item.fromAudio,
                              text: item.text
                            }, null, 8, ["fromAudio", "text"]))
                          : (_openBlock(), _createBlock(_component_OwnChat, {
                              key: 3,
                              text: item.text,
                              fromAudio: item.fromAudio
                            }, null, 8, ["text", "fromAudio"]))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["class"])
        ], 2)
      ]),
      _: 1
    }, 8, ["height", "anchors"]), [
      [_vShow, !_ctx.iscallingUmi && !_ctx.showEvaluationView && !_ctx.showReviewExercisesView && (!_ctx.showInteractiveGuide && _ctx.sdkToken && !_ctx.hideInteractive &&
      _ctx.initUnityCallBack &&
      _ctx.webrtcConnect)]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(['send-content', !_ctx.speakButtonSelect || _ctx.speakInfoSendState == 3 || _ctx.speakInfoSendState == 4 ? 'white-background-send-content' : ''])
    }, [
      (!_ctx.speakButtonSelect)
        ? (_openBlock(), _createBlock(_component_van_field, {
            key: 0,
            ref: "inputfield",
            modelValue: _ctx.message,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.message) = $event)),
            rows: "1",
            type: "textarea",
            autosize: "",
            placeholder: "请输入...",
            enterkeyhint: "send",
            onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.inputFocus())),
            onKeydown: _ctx.handleKeyboard
          }, null, 8, ["modelValue", "onKeydown"]))
        : _createCommentVNode("", true),
      (_ctx.speakButtonSelect)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            (_ctx.showUmiAudioView && _ctx.speakInfoSendState === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, " - 松手后发送，上移可取消 - "))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              ref: "speakCenterBtnRef",
              class: _normalizeClass([
          'speak_center_btn'
        ]),
              onTouchstart: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.speakCenterBttonClick && _ctx.speakCenterBttonClick(...args))),
              onTouchend: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleSpeakCenterButtonEndClick && _ctx.handleSpeakCenterButtonEndClick(...args))),
              onTouchcancel: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleSpeakCenterButtonEndClick && _ctx.handleSpeakCenterButtonEndClick(...args))),
              onTouchmove: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.updatePosition && _ctx.updatePosition(...args)))
            }, [
              (_ctx.speakInfoSendState != 3 && _ctx.speakInfoSendState != 4)
                ? (_openBlock(), _createBlock(_component_ChatMic, {
                    key: 0,
                    ref: "speakMicRef",
                    class: _normalizeClass([
            'hold_down_speak_tips'
          ])
                  }, null, 512))
                : _createCommentVNode("", true),
              (_ctx.speakInfoSendState === 2)
                ? (_openBlock(), _createBlock(_component_UmiAudioListenLoadingView, { key: 1 }))
                : _createCommentVNode("", true)
            ], 544),
            (_ctx.showUmiAudioView)
              ? (_openBlock(), _createBlock(_component_UmiAudioInfoView, {
                  key: 1,
                  speakInfoSendState: _ctx.speakInfoSendState,
                  onStopCountDownMethod: _ctx.stopCountDownMethod,
                  onCloseUmiSpeak: _ctx.closeUmiSpeak,
                  umiName: _ctx.npcName,
                  class: "umi_audio_info"
                }, null, 8, ["speakInfoSendState", "onStopCountDownMethod", "onCloseUmiSpeak", "umiName"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.message.length > 0)
        ? (_openBlock(), _createBlock(_component_ChatLottie, {
            key: 2,
            disabled: _ctx.answering,
            onClick: _cache[12] || (_cache[12] = () => _ctx.toAnswer(_ctx.message)),
            autoPlay: true,
            ref: "sendChat",
            class: "talk-btn",
            title: "发送"
          }, null, 8, ["disabled"]))
        : (_ctx.speakInfoSendState == 0)
          ? (_openBlock(), _createBlock(_component_van_button, {
              key: 3,
              disabled: _ctx.speakInfoSendState != 0 || _ctx.answering,
              class: _normalizeClass(['speak-mic-btn', _ctx.speakButtonSelect ? 'speak-btn' : 'mic-btn']),
              onClick: _ctx.speakButtonClick
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _ctx.speakButtonSelect
          ? require('../assets/image/chat_speak_keybord.svg')
          : require('../assets/image/chat_micphone_icon.svg')
          ,
                  class: "speak-btn-mic"
                }, null, 8, _hoisted_23)
              ]),
              _: 1
            }, 8, ["disabled", "class", "onClick"]))
          : _createCommentVNode("", true)
    ], 2), [
      [_vShow, !_ctx.iscallingUmi && !_ctx.showEvaluationView && !_ctx.hideInteractive && !_ctx.showReviewExercisesView]
    ]),
    (_ctx.showVideoPlayTriggerView)
      ? (_openBlock(), _createBlock(_component_VideoTriggerPlayView, {
          key: 3,
          onDismissVideoTriggerPlay: _ctx.dismissVideoTriggerPlayView,
          showVideoUrl: _ctx.showVideoUrl
        }, null, 8, ["onDismissVideoTriggerPlay", "showVideoUrl"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_EvaluationView, {
      ref: "evaluationViewRef",
      show: _ctx.showEvaluationView,
      evaluationList: _ctx.evaluationList,
      onExitEvaluationView: _ctx.exitEvaluationView,
      onVoicePlayText: _ctx.voicePlayText,
      onSetReportId: _ctx.setReportId
    }, null, 8, ["show", "evaluationList", "onExitEvaluationView", "onVoicePlayText", "onSetReportId"]), [
      [_vShow, _ctx.showEvaluationView]
    ]),
    (_ctx.showInteractiveGuide)
      ? (_openBlock(), _createBlock(_component_InteractiveGuidanceView, {
          key: 4,
          tips: _ctx.showReviewExercisesView ? '点击读题' : '点击互动',
          onCloseInteractiveGuide: _ctx.closeInteractiveGuide
        }, null, 8, ["tips", "onCloseInteractiveGuide"]))
      : _createCommentVNode("", true),
    (_ctx.showReviewExercisesView)
      ? (_openBlock(), _createBlock(_component_ReviewExercisesView, {
          key: 5,
          show: _ctx.showReviewExercisesView,
          canRead: !_ctx.showInteractiveGuide,
          speakInfoSendState: _ctx.speakInfoSendState,
          reviewBookId: _ctx.reviewBookId,
          webrtcConnect: _ctx.webrtcConnect,
          reviewCourseId: _ctx.reviewCourseId,
          onCloseReviewExercisesView: _ctx.closeReviewExercisesView,
          onVoicePlayText: _ctx.sceneSwitchvoicePlayText,
          onHasQuestionInfo: _ctx.hasQuestionInfo
        }, null, 8, ["show", "canRead", "speakInfoSendState", "reviewBookId", "webrtcConnect", "reviewCourseId", "onCloseReviewExercisesView", "onVoicePlayText", "onHasQuestionInfo"]))
      : _createCommentVNode("", true)
  ], 512))
}